'use client'

import { createContext, RefObject, useContext } from 'react'

interface ChatContainerContextValue {
  containerRef: RefObject<HTMLDivElement | null>
  ownerDocument: Document
}

export const ChatContainerContext = createContext<ChatContainerContextValue | null>(null)

export function useChatContainer() {
  const context = useContext(ChatContainerContext)
  if (!context) {
    throw new Error('useChatContainer must be used within ChatContainerContext.Provider')
  }
  return context
}
